<template>
  <Transition name="reward"
    ><div v-if="visible" class="credit-reward" role="status">
      <i class="ri-coin-line" /><strong>+{{ credits }} Credits</strong><span>已到账</span>
    </div></Transition
  >
</template>
<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useCreditStore } from '@/stores/credit.store';
const visible = ref(false);
const credits = ref(0);
const store = useCreditStore();
let timer: ReturnType<typeof setTimeout> | null = null;
async function show(event: Event): Promise<void> {
  credits.value = Number(
    (event as CustomEvent<{ session?: { rewardCredits?: number } }>).detail?.session
      ?.rewardCredits ?? 0,
  );
  await store.refreshAccount();
  visible.value = true;
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    visible.value = false;
  }, 1800);
}
onMounted(() => window.addEventListener('advertising-rewarded', show));
onBeforeUnmount(() => {
  window.removeEventListener('advertising-rewarded', show);
  if (timer) clearTimeout(timer);
});
</script>
<style scoped>
.credit-reward {
  position: fixed;
  z-index: 2000;
  top: 82px;
  left: 50%;
  display: grid;
  grid-template-columns: auto auto;
  gap: 0 8px;
  align-items: center;
  min-width: 190px;
  padding: 13px 18px;
  border-radius: 14px;
  color: #fff;
  background: linear-gradient(120deg, #4338ca, #0f766e);
  box-shadow: 0 16px 34px rgb(30 41 59 / 30%);
  transform: translateX(-50%);
}
.credit-reward i {
  grid-row: span 2;
  font-size: 26px;
}
.credit-reward strong {
  font-size: 17px;
}
.credit-reward span {
  opacity: 0.82;
  font-size: 12px;
}
.reward-enter-active,
.reward-leave-active {
  transition:
    opacity 220ms ease-out,
    transform 220ms ease-out;
}
.reward-enter-from,
.reward-leave-to {
  opacity: 0;
  transform: translate(-50%, -12px);
}
</style>
